import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'
import z from 'zod/v3'
import { withRoutePermissions } from '~/utils/rbac'
import { AddProductPage1 } from '../../../components/routes/products/AddProductPage1'
import { AddProductPage2 } from '../../../components/routes/products/AddProductPage2'
import { AddProductPage3 } from '../../../components/routes/products/AddProductPage3'
import { AddProductPage4 } from '../../../components/routes/products/AddProductPage4'
import ProductsOutletProvider from '../../../components/routes/products/ProductsOutletProvider'
import { stepsSchema, type Step } from './new'

export const Route = createFileRoute('/_authenticated/products/$productId/edit')({
  staticData: {
    permission: ['edit', 'products.products.product'],
  },
  component: UpdateProductStepPage,
  params: {
    parse: z.object({ productId: z.coerce.number() }).parse,
  },
  validateSearch: z.object({ step: stepsSchema.optional() }),
})
withRoutePermissions(Route)

const stepComponents = {
  1: AddProductPage1,
  2: AddProductPage2,
  3: AddProductPage3,
  4: AddProductPage4,
} satisfies Record<Step, () => JSX.Element>

function UpdateProductStepPage() {
  const { step = 1 } = Route.useSearch()
  const { productId } = Route.useParams()

  const Component = stepComponents[step]

  return (
    <ProductsOutletProvider productId={productId}>
      <Component />
    </ProductsOutletProvider>
  )
}
